export default __webpack_public_path__ + "static/media/DSC04643.cc8809b2.JPG";